export default [
    {
        lines: [
            "==========================================",
            " Exo Oil internal OS v. 135.32.394        ",
            "==========================================",
        ],
        startAt: 500,
        disableInput: true
    },
    {
        lines: ["Booting..."],
        startAt: 1000,
        disableInput: true
    },
    {
        lines: [
            "...",
        ],
        startAt: 2000,
        disableInput: true
    },
    {
        lines: [
            "..."
        ],
        startAt: 3000,
        disableInput: true
    },
    {
        lines: [
            "Welcome to Exo Oil internal OS!"
        ],
        startAt: 4000
    }
];